import axios from "axios";
import React, { useState } from "react";
import { ProductCard } from "./ProductCard";

const ProductSelection = ({
  userId,
  token,
  url,
  purchasedPhysical,
  physical,
  workshop,
  sst,
  bypassSoldOut,
}) => {
  const [selected, setSelected] = useState(null);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);

  return (
    <div id="productSelection">
      <form action={url} method="POST">
        <input type="hidden" name="authenticity_token" value={token} />
        <input type="hidden" name="product_ids" value={[selected, selectedWorkshop]} />

        <ProductCard
          cardTitle={"7th WORLD CONGRESS OF THE ASAMI-BR & ILLRS SOCIETIES"}
          products={physical}
          selectedState={selected}
          setSelectedState={setSelected}
          activated={!purchasedPhysical}
          bypassSoldOut={bypassSoldOut}
          handleCheckbox={(e) => {
            if (!e.target.checked) {
              setSelected(null);
              // setSelectedGalaDinner(null);
            }
          }}
          handleRadio={() => {
            // setSelectedGalaDinner(null);
          }}
        />

        {/* TODO: Unlock for phase 2 */}
        {/* <ProductCard
          cardTitle={"Pre-Conference Workshop (Optional)"}
          products={workshop}
          selectedState={selectedWorkshop}
          setSelectedState={setSelectedWorkshop}
          activated={selected || purchasedPhysical}
          bypassSoldOut={bypassSoldOut}
          handleCheckbox={(e) => {
            if (!e.target.checked) {
              setSelectedWorkshop(null);
              // setSelectedGalaDinner(null);
            }
          }}
          handleRadio={() => {
            // setSelectedGalaDinner(null);
          }}
        /> */}

        {sst && (
          <strong className="mx-auto d-block">
            All purchases will incur 8% SST
          </strong>
        )}
        {/* for international delegate is compulsory to select one of the precongress */}
        <button
          type="submit"
          className="mx-auto mt-4 text-white btn btn-primary d-block"
          disabled={
            selected === null && purchasedPhysical === null
            // purchasedPhysical
            //   ? purchasedPhysical && selectedGalaDinner === null
            //   : (selected === null && selectedGalaDinner === null) ||
            //     selected === null
          }
        >
          Purchase Pass
        </button>
      </form>
    </div>
  );
};

export default ProductSelection;
